// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_expo_vector-icons_Ionicons_js-node_modules_expo_vector-icons_MaterialCom-153bb4"], () => (__webpack_require__("./index.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
